import type { TFunction } from 'i18next';

import type { FilterDef, FilterOption } from '@nucleus-commerce/admin-kit/index-table';
import { PageStatus, PageTemplate, type Page } from '@nucleus-commerce/api-client/admin';

/** Fields GET /pages sorts on; anything else is a 400. */
export const PAGE_SORTS = ['title', 'updatedAt'] as const;

const valuesOf = (values: Record<string, string>): FilterOption[] =>
  Object.values(values).map((value) => ({ value, label: value }));

/**
 * The filters as the URL and the API spell them, for the route's search schema and loader. The
 * enum `options` drop unknown values the same way the page's filters do, so the prefetch and the
 * page share a query key.
 */
export const PAGE_FILTER_FIELDS = [
  { key: 'status', type: 'enum', options: valuesOf(PageStatus) },
  { key: 'template', type: 'enum', options: valuesOf(PageTemplate) },
  { key: 'updatedAt', type: 'date-range' },
] as const;

/** Filters of the pages table, in the order the filter menu lists them. `t` is `pages`. */
export function pageFilters(t: TFunction): Array<FilterDef<Page>> {
  const options = (values: Record<string, string>, prefix: string): FilterOption[] =>
    valuesOf(values).map(({ value }) => ({ value, label: t(`${prefix}.${value}`) }));

  return [
    {
      key: 'status',
      label: t('filters.status'),
      type: 'enum',
      pinned: true,
      options: options(PageStatus, 'status'),
    },
    {
      key: 'template',
      label: t('filters.template'),
      type: 'enum',
      pinned: true,
      options: options(PageTemplate, 'template'),
    },
    { key: 'updatedAt', label: t('filters.updatedAt'), type: 'date-range', aliases: ['updated'] },
  ];
}
